export default "__VITE_ASSET__BdfRGgSL__"